import React, { useMemo, useState, useEffect } from "react";

import PanelLayout from "components/base/PanelLayout";
import PageHeader from "components/base/PageHeader";
import ModalCreateModifyUser from "./ModalCreateModifyUser";
import ModalRemoveUser from "./ModalRemoveUser";
import UsersFilter from "./UsersFilter";
import UsersTable from "./UsersTable";
import { useWindowWidth } from "hooks";


export default (
    {
        data,
        loading,
        getManagerAccountUser,
        adminRoleList
    }
) => {

    const [filters, setFilters] = useState({
        str: "",
        role_list: [],
        show_only_active: true,
    });

    const windowWidth = useWindowWidth();
    const isMobile = windowWidth < 768;


    const [activeUserId, setActiveUserId] = useState(null);
    const [showModalRemove, setShowModalRemove] = useState(false);
    const [editableUserFormData, setEditableUserFormData] = useState(null);
    const [showModalCreate, setShowModalCreate] = useState(null);

    const activeUserName = useMemo(() => {
        if (!data || !activeUserId) {
            return null;
        }
        return data.find(item => item.id === activeUserId);
    }, [data, activeUserId]);

    useEffect(() => {
        getManagerAccountUser();
    }, []);

    const filteredData = useMemo(() => {
        return data.filter(item => {
            if (filters.show_only_active && !item.active) {
                return false;
            }

            if (filters.str) {
                const searchStr = filters.str.toLowerCase();
                const fullNameStr = `${item.name}${item.surname ? " " + item.surname : ""}`.toLowerCase();

                const hasSearchStr =
                    fullNameStr.includes(searchStr) ||
                    item?.email?.toLowerCase()?.includes(searchStr) ||
                    item?.telegram_username?.toLowerCase()?.includes(searchStr) ||
                    item?.login?.toLowerCase()?.includes(searchStr);

                if (!hasSearchStr) {
                    return false;
                }
            }

            if (filters?.role_list.length > 0) {
                const hasRole = filters.role_list.some(role =>
                    item.role_list.includes(role)
                );

                if (!hasRole) {
                    return false;
                }
            }

            return true;
        });
    }, [filters.show_only_active, filters.str, filters.role_list, data]);


    useEffect(() => {
        const userData = activeUserId
            ? data.find(item => item.id === activeUserId)
            : null;

        const params = userData
            ? {
                name: userData.name,
                surname: userData.surname,
                phone: userData.phone,
                email: userData.email,
                login: userData.login,
                role_list: userData.role_list,
                active: userData.active,
                telegram_username: userData.telegram_username,
                telegram_id_ready: userData.telegram_id_ready
            }
            : null;

        if (params) {
            for (const prop of Object.keys(params)) {
                if (params[prop] === null) {
                    delete params[prop];
                }
            }
        }

        setEditableUserFormData(params);
    }, [data, activeUserId]);

    return (
        <PanelLayout>
            <PageHeader extraTitle="Admin Panel Users" />
            <UsersFilter
                filters={filters}
                setFilters={setFilters}
                isMobile={isMobile}
                roleList={adminRoleList}
                setShowModalCreate={setShowModalCreate}
            />

            <UsersTable
                data={filteredData}
                loading={loading}
                adminRoleList={adminRoleList}
                getManagerAccountUser={getManagerAccountUser}
                {...{
                    setActiveUserId,
                    setShowModalRemove,
                    setShowModalCreate,
                }}
            />

            <ModalRemoveUser
                show={showModalRemove}
                userId={activeUserId}
                title={<>Remove user <b>{activeUserName && activeUserName.name}</b></>}
                onClose={() => {
                    setShowModalRemove(false);
                    setActiveUserId(null);
                }}
                onUpdate={getManagerAccountUser}
            />

            <ModalCreateModifyUser
                show={showModalCreate}
                userId={activeUserId}
                userFormValue={editableUserFormData}
                title={activeUserName ? `Modify user ${activeUserName.name}` : "Create new user"}
                onClose={() => {
                    setShowModalCreate(false);
                    setActiveUserId(null);
                }}
                onUpdate={getManagerAccountUser}
                adminRoleList={adminRoleList}
            />


        </PanelLayout>
    );
};